import React from 'react';
import { speakInterventionLeadIn } from '../../services/interventionSelection';
import { getUserData } from '../../services/API';
import { listen } from '../../services/Listen';
import FlashWord from '../FlashWord';
import WordInterventionModal from '../WordInterventionModal';
import { COPY_STRINGS } from '../../constants/translatedCopy';
import { interventionType } from '../../constants/interventionSelectionConstants';
import pronounce_icon from "../../images/intervention_icons/pronounce.svg";

function SightWordInstructions ({ word }) {
  const Say = COPY_STRINGS.intervention_strings.say[0].toUpperCase() + COPY_STRINGS.intervention_strings.say.slice(1);
  return (
    <div>
      {Say} <span className="keyword">{word}</span> 3 {COPY_STRINGS.intervention_strings.times}
    </div>
  );
}

export default class SightWord extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      canFlash: false,
      message: null,
    };

    this.speakSightWord = this.speakSightWord.bind(this);
    this.startWordFlash = this.startWordFlash.bind(this);
    this.stopWordFlash = this.stopWordFlash.bind(this);
    this.wordDoneFlashing = this.wordDoneFlashing.bind(this);
  }

  componentDidMount() {
    this.props.handleMessage({
      speakFunction: this.speakSightWord,
      callback: () => {
          this.stopWordFlash();
          this.props.handleMessage({continueWithoutSpeaking: true, endOfPhrase: this.props.endOfPhrase});
        },
    });
  }

  componentWillUnmount() {
    this.stopWordFlash();
  }

  speakSightWord(onEnd) {
    const { speech, inWord } = this.props;
    speakInterventionLeadIn(speech, interventionType.sayit, inWord);
    const onSpeechEnd = this.listenAndFlashWord.bind(this, onEnd);

    if(getUserData().bilingualMode){
      speech.speak({textToSpeak: "<prosody rate=\"slow\"> " + inWord + " </prosody>", skipTranslation: true}, undefined, undefined, true);
      speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.important_word + ":"}, undefined, undefined, true);
      speech.speak({textToSpeak: "<prosody rate=\"slow\"> " + inWord + " </prosody>", skipTranslation: true});
      speech.speak({textToSpeak: COPY_STRINGS.intervention_strings.three_times, onEnd: onSpeechEnd, passThroughSpeechTags: true});
    } else {
      let textToSpeak = "<prosody rate=\"slow\">" + inWord + " </prosody> "  + COPY_STRINGS.intervention_strings.important_word + " <prosody rate=\"slow\"> " + inWord + " </prosody>" + COPY_STRINGS.intervention_strings.three_times;
      speech.speak({textToSpeak: textToSpeak, onEnd: onSpeechEnd, passThroughSpeechTags:true});
    }
  }

  listenAndFlashWord(onEnd){
    const { inWord } = this.props;
    this.startWordFlash();
    listen({
      speech: this.props.speech,
      targetWord: inWord,
      callback: onEnd,
      interventionType: interventionType.sight,
    });
  }

  startWordFlash(onEnd){
    this.setState({
      canFlash: true,
      onEnd: onEnd,
    });
  }

  stopWordFlash(){
    this.setState({canFlash: false});
  }

  wordDoneFlashing(){
    this.setState({canFlash: false},this.state.onEnd);
  }

  render() {
    const { inWord } = this.props;

    return (
      <WordInterventionModal
        word={this.state.canFlash ? <FlashWord word={inWord} onEnd={this.wordDoneFlashing} /> : inWord}
        icon={pronounce_icon}
        useWordIcon={true}
        instructions={<SightWordInstructions word={inWord} />}
      />
    );
  }
}